







import ContentBlocks from "~/components/ContentBlocks.vue";
import {defineComponent} from "@nuxtjs/composition-api";

export default defineComponent({
  name: 'InformationBlock',
  components: {
    ContentBlocks
  },
  data() {
    return {
      productPageInformationBlockID: ['information_blocks_under_banner']
    };
  }
});
